// third-party
// assets
import { IconRouter, IconDevicesSearch } from '@tabler/icons-react';
import { permissions } from '../auth/config';

// constant
const icons = {
  IconRouter,
  IconDevicesSearch
};

// ==============================|| APPLICATION MENU ITEMS ||============================== //

const devices = {
  id: 'devices',
  title: 'Devices',
  // title: <FormattedMessage id="accounts" />,
  icon: icons.IconRouter,
  type: 'group',
  permission: permissions.VIEW_DEVICES,
  children: [
    {
      id: 'search-devices',
      title: 'Search Devices',
      // title: <FormattedMessage id="Search Devices" />,
      type: 'item',
      icon: icons.IconDevicesSearch,
      url: '/devices',
      breadcrumbs: false,
      permission: permissions.VIEW_DEVICES,
      children: [
        {
          id: 'device-info',
          title: 'Device Info',
          // title: <FormattedMessage id="Device Info" />,
          type: 'item',
          url: '/devices/device-info',
          icon: icons.IconRouter,
          breadcrumbs: true,
          permission: permissions.VIEW_DEVICES
        }
      ]
    }
  ]
};

export default devices;
